import { render, staticRenderFns } from "./product-attribute.vue?vue&type=template&id=cf824eec&scoped=true&"
import script from "./product-attribute.vue?vue&type=script&lang=js&"
export * from "./product-attribute.vue?vue&type=script&lang=js&"
import style0 from "./product-attribute.vue?vue&type=style&index=0&id=cf824eec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf824eec",
  null
  
)

export default component.exports